// Import and register all your controllers from the importmap via controllers/**/*_controller
//import { application } from "controllers/application"
import { application } from "./application"

// dimlevel
import DimlevelController from "./dimlevel_controller"
application.register("dimlevel", DimlevelController)

// zone selection
import ZoneSelectController from "./zone_select_controller"
application.register("zone-select", ZoneSelectController)

// tempus dominus
//import TempusDominusController from "./tempus_dominus_controller"
//application.register("tempus-dominus", TempusDominusController)

// flatpickr
import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)
